import { render, staticRenderFns } from "./ProductPackageList.vue?vue&type=template&id=d0909006&"
import script from "./ProductPackageList.vue?vue&type=script&lang=js&"
export * from "./ProductPackageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports